import { useEffect, useState } from "react"
import { deleteParaparItem, getParaparDetails } from "../../../api"
import { mountApiUrl } from "../../../api/utils"
import config from "../../../environments/generated.config"
import { useBasket, useLoading, getHasBasketContent } from "../../../providers"
import { Layout } from "./Layout"
import { Layout as ProgressiveLayout } from "./Layout/progressive"

export const Parapar = ({ item }) => {
  const [collapse, setCollapse] = useState(false)

  const [details, setDetails] = useState([])

  const { basketReload } = useBasket()
  const { setLoading } = useLoading()

  const editUrl = mountApiUrl(config.urls.home, config.urls.edit, {
    order_type: "parapar",
    product_id: item.produto,
    order_os: item.OS,
  })

  const [editRoute] = useState(editUrl)

  const getDetails = async () => {
    setLoading(true)
    try {
      const data = await getParaparDetails(item.produto, item.OS)
      data.SUCCESS ? setDetails(data.RESULT) : setCollapse(false)
      setLoading(false)
    } catch (error) {
      setCollapse(false)
      setLoading(false)
    }
  }

  const toggleCollapse = () => setCollapse(!collapse)

  useEffect(() => {
    collapse && getDetails()
  }, [collapse])

  const handleDelete = async () => {
    await deleteParaparItem(item.produto, item.OS)
    await basketReload()
    await getHasBasketContent()
  }

  const progressiveLen = item.produto?.startsWith("FP")

  const layoutProps = {
    item,
    editRoute,
    collapse,
    details,
    handleDelete,
    toggleCollapse,
  }

  return progressiveLen ? <ProgressiveLayout {...layoutProps} /> : <Layout {...layoutProps} />
}
